import { Player } from "@lottiefiles/react-lottie-player";
import React from "react";

const NotFound = () => {
  return (
    <div>
      <h1 className="display-1 text-center my-5 fw-bolder pb-3" style={{color: '#37e813'}}>Please enter correct url</h1>
      <Player
        autoplay
        loop
        src="https://assets8.lottiefiles.com/packages/lf20_sdd6siet.json"
        style={{ width: '50%' }} />
    </div>
  );
};

export default NotFound;
